/**
 * Created by zhj on 3/24/2016.
 */
'use strict';

angular.module('betosyswebapp')
  .controller('PortalCommandCtrl', function ($rootScope, $scope, AuthenticationService, base64, localStorageService, $translate, commonTrackService, dashboardService, customerService) {
    $scope.pageHeader = 'PortalCommand Dashboard';

    var loginID = AuthenticationService.GetLoginID();

    //dash board
    $scope.username = loginID.username;
    $scope.dashBoardName = 'dashBoard.PortalCommand.' + $scope.username;
    var model = localStorageService.get($scope.dashBoardName);

    if (!model) {
      model = customerService.getPortalCommandDashboardConfig(commonTrackService.getViewPortName());
    }


    $scope.dashBoardModel = model;
    $scope.collapsible = true;
    $scope.maximizable = true;

    $scope.widgetFilter = function (widget, type) {
      if (widget.isSingleInstance === undefined || notExist(type)) {
        return type;
      }
    };

    function notExist(type) {
      return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
    }

    var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
      localStorageService.set(name, model);
    });

    var rowSelectedEvnt = $scope.$on('vehiclesListRowSelected', function (event, data) {
      if (data.selectedRow) {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
      } else {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
      }
    });

    $scope.$on('$destroy', function () {
        rowSelectedEvnt();
        adfDashboardChangedEvnt();
      }
    );
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/portalCommand/portalCommandController.js